import React from "react";
import "./projects.css";
import fylo_img from "../project_images/fylo_image.png";
import movie_img from "../project_images/movie_database.png";
import resume_img from "../project_images/resume.png";

function Projects() {
  return (
    <div className="whole-project">
      <div className="project_header">
        <h4>Projects</h4>
      </div>
      <div className="card-deck deckss">
        <div className="card cardss">
          <img src={fylo_img} alt="fylo image" />

          <div className="card-body">
            <div className="year">
              <h6>2022</h6>
            </div>
            <a href={" https://maifoozc.github.io/fylo-project/"}>Fylo</a>
          </div>
        </div>

        <div className="card cardss">
          <img src={movie_img} alt="movie_img" />

          <div className="card-body">
            <div className="year">
              <h6>2022</h6>
            </div>
            <a href={"https://maifoozc.github.io/movieDatabase/"}>
              Movie Database
            </a>
          </div>
        </div>

        <div className="card cardss">
          <img src={resume_img} />

          <div className="card-body">
            <div className="year">
              <h6>2022</h6>
            </div>
            <a href={"https://maifoozc.github.io/Resume/"}> Resume</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
